function bindInstanceMethods(instance) {
  return Object.getOwnPropertyNames(Object.getPrototypeOf(instance)).filter((key) => typeof instance[key] === "function").reduce((acc, key) => {
    const method = instance[key];
    if (typeof method === "function") {
      acc[key] = method.bind(instance);
    }
    return acc;
  }, {});
}
export {
  bindInstanceMethods
};
//# sourceMappingURL=utils.js.map
